<template>
  <div id="app">
    <HomePage/>
  </div>
</template>

<script>
import HomePage from './pages/HomePage.vue'

export default {
  name: 'app',
  components: {
    HomePage
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Karla|Noto+Sans');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

html, body {
  margin: 0;
  padding: 0;
}

.icon {
  font-family: 'Material Icons';
}

#app {
  font-size: 16px;
  font-family: 'Karla', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2D2D2D;
}
</style>
